<div class="flex flex-col grow gap-2 min-h-0">
    <section class="rounded-md p-4 !bg-white flex flex-col gap-4 grow min-h-0">
        <div class="flex items-center gap-2">
            <app-title
                class="header-title font-medium text-2xl"
                [title]="title() ?? ''"
                (goToPreviousPage)="onDetailClose()" />
        </div>
        <section
            cdk-scrollable
            class="overflow-y-auto overflow-x-hidden">
            <router-outlet />
        </section>
    </section>

    <div
        class="flex flex-wrap flex-row items-center gap-2 rounded-md bg-white px-2 z-10 py-3"
        [class.justify-between]="hasDeleteAction()">
        @for (action of actions(); track action.label) {
            <app-button
                iconSize="sm"
                [disabled]="!action.isActive"
                [icon]="action.icon"
                [label]="action.label"
                [loading]="action.loading"
                [matTooltip]="action.tooltipMessage"
                [type]="action.type"
                (onClick)="action.onClick()" />
        }
    </div>
</div>
